export const NETWORK_TYPES = {
  crypto: { networkId: 0, networkName: "Crypto" },
  fiat: { networkId: 1, networkName: "FIAT" },
};

export const TYPES = {
  sanaCash: 1,
  core: 2,
  internal: 3,
  paymentGateway: 4,
};

export const HELP_QUESTIONS_CRYPTO = [
  {
    title: "راهنمای واریز ارز دیجیتال (Deposit)",
    answer: `
    اگر ارز رمزنگاری شده در سیستم عامل یا کیف پول دیگری دارید، می
    توانید آن ها را برای تجارت به کیف پول ساناکش خود منتقل کنید.
    <br /> ابتدا از منوی <span class="blue-text">
      Wallet
    </span>
    وارد اسپات ولت <span class="blue-text">Spot Wallet</span> خود
    شده، بر روی دکمه
    <span class="blue-text"> Deposit </span> کلیک کنید.
    <br /> در صفحه نمایش داده شده تب
    <span class="blue-text"> Crypto </span> به صورت پیشفرض انتخاب
    شده است. <br />
    جهت واریز ارز دیجیتال، <span class="blue-text">Coin</span> خود
    را از قسمت <span class="blue-text"> Select Coin </span> انتخاب
    نمایید. <br />
    در قسمت <span class="blue-text">Deposit to</span> شما دو یا سه
    انتخاب به شرح ذیل خواهید داشت:
    <br />
    <span class="blue-text n-weight-500"> • SanaCash: </span> با
    انتخاب این گزینه شما می توانید از طریق پشتیبانی تلگرام
    SanaCash آدرس ولت <span class="blue-text"> Coin </span> مورد نظر
    را دریافت و واریز ارز دیجیتال را انجام دهید.
    <br /> <br />
    <span class="blue-text n-weight-500">• Core:</span> این گزینه
    برای ارزهای <span class="blue-text">BTC </span>،
    <span class="blue-text">ETH </span>،
    <span class="blue-text">USDT </span> و
    <span class="blue-text"> TRX </span> قابل انتخاب است.
    <br /> شایان ذکر است که واریز با استفاده از این گزینه به صورت 24
    ساعته قابل استفاده است. <br />
    با انتخاب این گزینه در قسمت
    <span class="blue-text">Details</span>، با کلیک بر دکمه نمایش
    آدرس ولت آدرس ولت و <span class="blue-text"> QR code </span> ارز موردنظر نمایش داده می شود.
    <br /> شما می توانید با استفاده از آن اقدام به واریز ارز انتخابی
    خود نمایید.
    <br />
    <br />
    <span class="blue-text n-weight-500">• Internal:</span> این
    گزینه برای انتقال داخلی ارزهای دیجیتال بدون کارمزد بین کاربران
    <span class="blue-text">SanaCash</span> می باشد.
 
  `,
  },
  {
    title: "شناسه تراکنش (TxID ) چیست؟",
    answer:
      "شناسه تراکنش (TxID) یا هش تراکنش یک رشته منحصر به فرد از کاراکترها است که به هر معامله تأیید شده و به بلاکچین اضافه می شود. به عبارت دیگر، TxID یک شماره شناسایی است که هر معامله را در بلاکچین برچسب گذاری می کند. با استفاده از TxID می توانید سابقه واریز و برداشت خود را جستجو کنید.",
  },
  {
    title: "چگونه TxID خود را پیدا کنم؟",
    answer: `
    ابتدا وارد حساب ساناکش خود شده، سپس وارد اسپات ولت شوید روی
    <span class="blue-text"> Withdraw </span>
    کلیک کنید، در قسمت پایین صفحه اطلاعات آخرین تراکنش ها که شامل
    <span class="blue-text"> TXID </span>
    است قابل مشاهده می باشد.
    <br /> علاوه بر این شما می توانید در اسپات ولت خود بر روی
    <span class="blue-text">History</span> کلیک نموده و اطلاعات
    سوابق تراکنش ها شامل <span class="blue-text"> TXID </span> را
    در این صفحه مشاهده کنید.
  `,
  },
];

export const HELP_QUESTIONS_FIAT = [
  {
    title: "راهنمای Deposit",
    answer: `
    <span class="blue-text n-weight-500"> • Type SanaCash: </span>
    برای شارژ اکانت کاربری خود از طریق راههای ارتباطی امن
    <span class="blue-text">SanaCash</span> با ما ارتباط بگیرید تا
    به شما شماره حساب بانکی شرکت یا لینک درگاه پرداخت اینترنتی داده
    شود، شما فقط مجاز به ارسال مبلغ
    <span class="blue-text">TOMAN</span> از حساب بانکی شخص خودتان
    هستید، لطفا از حساب دیگران به حسابهای اعلامی واریز مبلغ نداشته
    باشید. <br />
    راههای ارتباط با ما تلگرام ساناکش:
    <span class="blue-text"> https://t.me/SanaCash </span>
    <br />
    واتس اپ ساناکش:
    <span class="blue-text"> 00989381091635 </span>
    <br /> ایمیل ساناکش:
    <span class="blue-text">info@sanacash.net</span>
    <br />
    <br />
    <span class="blue-text n-weight-500"> • Type Internal: </span>
    با انتخاب این تایپ شما می توانید
    <span class="blue-text">Address ID</span> خود را به دیگر
    کاربران سایت داده تا از طریق انتقال داخلی بدون هیچ کارمزدی و بصورت
    آنی اکانت خود را شارژ کنید.
    <br />
    <br />
    <span class="blue-text n-weight-500">
      
      • Type Payment Gateeway:
    </span>
    دراین تایپ شما می توانید روزانه تا سقف پنجاه میلیون تومان از طریق
    درگاه اینترنتی اکانت کاربری خود را شارژ کنید، با پرداخت آنلاین،
    اکانت کاربری شما بصورت آنی شارژ خواهد شد. توجه داشته باشید که به
    دلایل امنیتی، شما باید در قسمت حسابهای بانکی حساب بانکی و شماره
    کارتی که قصد پرداخت آنلاین دارید را ایجاد و تعریف کنید، در صورت
    تایید توسط همکاران ما، شما مجاز به استفاده از پرداخت آنلاین از
    طریق درگاه بانکی خواهید بود.
    `,
  },
  {
    title: "مدت زمان شارژ شدن اکانت کاربری به TOMAN",
    answer: `
    <span class="blue-text n-weight-500">
      • پرداخت از طریق Payment Gateeway:
    </span>
    بصورت آنی شارژ خواهد شد.
    <br /> <br />
    <span class="blue-text n-weight-500">
      • پرداخت از طریق حسابهای بانکی :
    </span>
    به محض دریافت مبلغ به حساب یا حساب های بانکی داده شده ، اکانت
    کاربری شما شارژ خواهد شد.
    <br /> <br />
    <span class="blue-text n-weight-500">
      • پرداخت از طریق Internal:
    </span>
    بصورت آنی شارژ خواهد شد.
 `,
  },
  {
    title: "هنوز اکانت کاربری من شارژ نشده است؟",
    answer: `ممکن است شما مبلغ مورد نظر را به حسابهای ما ساتنا یا پایا کرده باشید که طبق قوانین بانکی در ساعات پایا یا ساتنا به حساب ما خواهد نشست، به محض دریافت مبلغ به حسابهای ما، اکانت شما شارژ خواهد شد.`,
  },
  {
    title: "حداقل واریز TOMAN به اکانت کاربری",
    answer: `حداقل واریز به اکانت کاربری به شما دراطلاع داده شده است، لطفا کمتر از حداقل واریز، به حسابهای ما واریزی نداشته باشید، اکانت شما شارژ نخواهد شد.`,
  },
  {
    title: "واریز از حساب اشخاص ثالث به حسابهای اعلامی",
    answer: `چنانچه شخص ثالث به نیابت از شما اقدام به واریز وجه به حساب­های معرفی شده از طرف ما نماید، درصورتی­که شخص واریز کننده، تعهدات و فرم های احراز هویت ما را تکمیل نموده و درخواست نماید که مبلغ واریزی برای شارژ حساب شما است، اکانت شما شارژ خواهد شد در غیر این صورت مبلغ واریزی به حسابهای ما ، به حساب واریز کننده عودت خواهد شد.`,
  },
  {
    title: " انتقال وجه به حساب کاربران داخل سایت",
    answer: `در Spot Wallet  بر روی گزینه Deposit  کلیک کنید، در بالای صفحه گزینه FIAT  را انتخاب کنید، در قسمت Deposit to   تایپ (Type)  Internal  را انتخاب کرده  به شما  Address ID   اکانت کاربری شما داده خواهد شد، آدرس را به واریز کننده مبلغ ارائه دهید تا بدون هیچ کارمزدی مبلغ مورد نظر را بصورت آنی به اکانت کاربری شما انتقال دهد.`,
  },
];
